import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { OUR_LEADERS } from "../../StaticData/aboutus";
import "./OurLeaderShip.css";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const OurLeaderShipTeam = () => {
  return (
    <div>
      <Helmet>
        <title>Our Leadership Team | Idexcel</title>
        <meta content="" name="keywords" />
        <meta
          content="In order to be the leader of a high-performing business team, you must encourage others and set clear goals. Meet our leadership team here."
          name="description"
        />
      </Helmet>

      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="leadership-banner-container p-0">
          <section className="leadership-banner-section"></section>
        </Container>
      </motion.div>

      <section className="our-leadership-section">
        <Container className="mb-5 px-xl-5">
          <Row className="p-0 m-0 pt-xl-0 pt-md-5 px-0 px-lg-3" >
            <h2 className="text-center mb-4 section-title">
              Meet Our <span className="textgrad">Leadership Team</span>{" "}
            </h2>

            {OUR_LEADERS?.map((leader, index) => {
              return (
                <Row
                  key={index}
                  className="m-0 p-0 d-flex justify-content-between flex-column flex-lg-row flex-md-row align-items-start py-4 mb-3"
                  style={{ borderTop: "1px solid #ccc" }}
                >
                  <Col className="m-0 p-0 col-lg-3 col-md-3 mt-2 d-flex justify-content-center justify-content-md-start">
                    <div className="leaders-pic">
                      <img src={leader?.img} />
                    </div>
                  </Col>
                  <Col className="m-0 p-0 col-lg-9 col-md-9 mt-2">
                    <h2 className="fw-semibold text-black m-0 mb-1 mt-2">
                      {leader?.name}
                    </h2>
                    <h3
                      className="fw-medium text-black m-0"
                      style={{ fontSize: "21px" }}
                    >
                      {leader?.designation}
                    </h3>
                    <p className="mt-3">{leader?.desc}</p>
                  </Col>
                </Row>
              );
            })}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default OurLeaderShipTeam;
